module.exports = __webpack_public_path__ + "static/Grafik_family.d0bb2019.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/PageHeader/Hero/Grafik_family.png
// module id = 424
// module chunks = 35783957827783